module.exports = {
    AdminProfileUpdated: 'admin-profile-updated',
    BankAccountCsvImportCompleted: 'bank-account-csv-import-completed',
    BankAccountReconciliationStartDateUpdated: 'bank-account-reconciliation-start-date-updated',
    BillCreated: 'bill-created',
    BillUpdated: 'bill-updated',
    ContactUpdated: 'contact-updated',
    InvoiceApproved: 'invoice-approved',
    InvoiceCreated: 'invoice-created',
    InvoiceUpdated: 'invoice-updated',
    EmberUserOrganizationsLoaded: 'ember-user-organizations-loaded',
    OrganizationOwnersUpdated: 'organization-owners-updated',
    OrganizationUnlocked: 'organization-unlocked',
    OrganizationSettingsUpdated: 'organization-settings-updated',
    OrganizationSettingsUpdatedInReactApp: 'organization-settings-updated-in-react-app',
    OrganizationUpdated: 'organization-updated',
    PaymentMethodsUpdated: 'payment-methods-updated',
    PaymentSaved: 'payment-saved',
    PaymentUpdated: 'payment-updated',
    QuoteCreated: 'quote-created',
    RoutingLinkClicked: 'routing-link-clicked',
    StripeIntegrationDeliverResult: 'stripe-integration-deliver-result',
    StripeIntegrationRequestResult: 'stripe-integration-request-result',
    TaxRulesetUpdated: 'tax-ruleset-updated',
    TaxRuleUpdated: 'tax-rules-updated',
    ThemeLayoutChanged: 'theme-layout-changed',
    ThemeLayoutModeChanged: 'theme-layout-mode-changed',
    TransactionCreated: 'transaction-created',
    TransactionUpdated: 'transaction-updated',
    TransactionsDaybookVoided: 'transactions-daybook-voided',
    TransactionsDaybookReversed: 'transactions-daybook-reversed',
    UploadsUpdated: 'uploads-updated',
    VatDeclarationInvalidated: 'vat-declaration-invalidated'
}
